import statuses from '@/store/statuses';
import Services from '@/services/index';
import VT from '@/store/types';

const NotificationsService = Services.notifications;
export default {
  [VT.NOTIFICATIONS]: ({ commit, state }, page = 1) => {
    state.notifications['status'] = statuses.LOADING;
    NotificationsService.list(page).then((data) => {
      commit(VT.NOTIFICATIONS, data);
    }).catch((errResponse) => {
      commit(VT.NOTIFICATIONS, errResponse);
    });
  },
  [VT.NOTIFICATIONS_NEW]: ({ commit, state }) => {
    state.notificationsNew['status'] = statuses.LOADING;
    NotificationsService.newNotificationsList().then((data) => {
      commit(VT.NOTIFICATIONS_NEW, data);
    }).catch((errResponse) => {
      commit(VT.NOTIFICATIONS_NEW, errResponse);
    });
  },
  [VT.NOTIFICATION_READ_UPDATE]: ({ commit, state }, { type, ids }) => {
    state.notificationsReadUpdate['status'] = statuses.LOADING;
    const updateType = type === 0 ? 'unread' : 'read';
    NotificationsService.notificationsReadUpdate(updateType, ids).then((data) => {
      commit(VT.NOTIFICATION_READ_UPDATE, data);
    }).catch((errResponse) => {
      commit(VT.NOTIFICATION_READ_UPDATE, errResponse);
    });
  },
};
